import Icon from '../../marker/rectangle/Rectangle';
import damStatusColor from './DamStatusColor';

const DamLargeColor = (val) => {
  let color;
  let icon;
  let colorCode;
  const damIcon = Icon;
  // const {
  //   grey, yellow, green, blue, red, brown,
  // } = damStatusColor;
  const grey = damStatusColor[0];
  const yellow = damStatusColor[1];
  const green = damStatusColor[2];
  const blue = damStatusColor[3];
  const red = damStatusColor[4];
  const brown = damStatusColor[5];

  if (val > 100) {
    color = brown;
    icon = damIcon.red;
  } else if (val > 80 && val <= 100) {
    color = red;
    icon = damIcon.red;
  } else if (val > 50 && val <= 80) {
    color = blue;
    icon = damIcon.blue;
  } else if (val > 30 && val <= 50) {
    color = green;
    icon = damIcon.green;
  } else if (val <= 30 && val > 0) {
    color = yellow;
    icon = damIcon.yellow;
  } else {
    color = grey;
    icon = damIcon.grey;
  }

  return { color, icon, colorCode };
};

export default DamLargeColor;
